import React from "react";
import { Constants } from "@videosdk.live/react-sdk";
import { sideBarModes } from "../../utils/common";

const MobileBottomBar = ({
  isMobileLike,
  isMobileLandscape,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  setShowMobilePanel,
  localMicOn,
  handleToggleMic,
  isTogglingMic,
  handleToggleWebcam,
  isTogglingWebcam,
  showMicDropdown,
  mics,
  selectedMic,
  changeMic,
  showAudioInputDropdown,
  setShowAudioInputDropdown,
  speakers,
  selectedSpeaker,
  setSelectedSpeaker,
  showSpeakerDropdown,
  setShowSpeakerDropdown,
  getMics,
  setShowMicDropdown,
  localWebcamOn,
  mMeeting,
  showVideoDropdown,
  webcams,
  selectedWebcam,
  changeWebcam,
  showVideoSourceDropdown,
  setShowVideoSourceDropdown,
  setShowVirtualBackgroundModal,
  getWebcams,
  setShowVideoDropdown,
  setSideBarMode,
  unreadChat,
  setUnreadChat,
  setShowHelpModal,
  handleLeaveModal,
}) => {
  if (!isMobileLike) return null;

  return (
    <div
      className={`fixed z-30 bg-[#060621] backdrop-blur-md ${
        isMobileLandscape
          ? "right-0 top-16 bottom-0 w-20 py-4 px-2 border-l border-slate-700"
          : "bottom-0 left-0 right-0 px-4 py-3 border-t border-slate-700"
      }`}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* Swipe Handle */}

      {!isMobileLandscape && <div
        className={`flex ${
          isMobileLandscape ? "justify-center mb-3" : "justify-center mb-2"
        } cursor-pointer`}
        onClick={() => setShowMobilePanel(true)}
      >
        <div
          className={`bg-gray-400 rounded-full hover:bg-gray-300 transition-colors ${
            isMobileLandscape ? "w-1 h-8" : "w-8 h-1"
          }`}
        ></div>
      </div>}

      {/* Main Controls */}
      <div
        className={`flex items-center ${
          isMobileLandscape
            ? "flex-col justify-around h-full"
            : "justify-around"
        }`}
      >
        {/* Mic */}
        <div className="relative">
          <div
            className={`flex flex-col items-center gap-1 ${
              isMobileLandscape ? "p-1" : "p-2"
            }`}
          >
            <div className="flex items-center gap-1">
              <img
                src={localMicOn ? "/icons/micOn.svg" : "/icons/micOff.svg"}
                alt="Mic"
                className={`object-cover hover:border-gray-400 transition-all duration-200 ${
                  isMobileLandscape ? "h-5" : "h-6"
                } ${isTogglingMic ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={isTogglingMic ? undefined : handleToggleMic}
                title={localMicOn ? "Mute" : "Unmute"}
              />
            </div>
            {!isMobileLandscape && (
              <span className="text-xs text-white">Mic</span>
            )}
          </div>

          {/* Mobile Mic Device Dropdown */}
          {showMicDropdown && (
            <div
              data-mic-dropdown
              className={`absolute w-64 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 ${
                isMobileLandscape
                  ? "right-full top-0 mr-2"
                  : "bottom-full left-1/2 transform -translate-x-1/2 mb-2"
              }`}
            >
              {/* Audio Input Section */}
              <div className="px-4 py-2">
                <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                  AUDIO INPUT
                </div>
                <div className="relative">
                  <div
                    className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm"
                    onClick={() => {
                      setShowAudioInputDropdown(!showAudioInputDropdown);
                    }}
                  >
                    <div className="flex items-center gap-3 min-w-0 flex-1">
                      <img
                        src="/icons/micOn.svg"
                        alt="Microphone"
                        className="flex-shrink-0"
                      />
                      <span className="font-medium truncate min-w-0">
                        {selectedMic?.label || "Select microphone"}
                      </span>
                    </div>
                    <img
                      src="/icons/chevronDown.svg"
                      alt="dropdown"
                      className={`transition-transform duration-200 ${
                        showAudioInputDropdown ? "rotate-180" : ""
                      }`}
                    />
                  </div>

                  {/* Device List */}
                  {showAudioInputDropdown && (
                    <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                      {mics.map((device) => (
                        <button
                          key={device.deviceId}
                          className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                          onClick={() => {
                            changeMic(device.deviceId);
                            setShowMicDropdown(false);
                          }}
                        >
                          <img
                            src="/icons/micOn.svg"
                            alt="Microphone"
                            className="flex-shrink-0"
                          />
                          <span className="truncate min-w-0">
                            {device.label ||
                              `Microphone ${device.deviceId.slice(0, 8)}...`}
                          </span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Audio Output Section */}
              <div className="px-4 py-2">
                <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                  AUDIO OUTPUT
                </div>
                <div className="relative">
                  <button
                    onClick={() => setShowSpeakerDropdown(!showSpeakerDropdown)}
                    className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm hover:bg-[#1a1a2e]/80 transition-colors min-w-0"
                  >
                    <div className="flex items-center gap-3 min-w-0 flex-1">
                      <svg
                        className="w-5 h-5 text-white flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                      </svg>
                      <span className="font-medium truncate min-w-0">
                        {selectedSpeaker?.label || "Select speaker"}
                      </span>
                    </div>

                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      className={`flex-shrink-0 ml-2 transition-transform duration-200 ${
                        showSpeakerDropdown ? "rotate-180" : ""
                      }`}
                    >
                      <path
                        d="M3.5 5.5L8 10l4.5-4.5"
                        stroke="currentColor"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      />
                    </svg>
                  </button>

                  {/* Speaker List */}
                  {showSpeakerDropdown && (
                    <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                      {speakers.map((device) => (
                        <button
                          key={device.deviceId}
                          className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                          onClick={() => {
                            setSelectedSpeaker({
                              id: device.deviceId,
                              label: device.label,
                            });
                            setShowSpeakerDropdown(false);
                          }}
                        >
                          <svg
                            className="w-4 h-4 text-white flex-shrink-0"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                          </svg>
                          <span className="truncate min-w-0">
                            {device.label ||
                              `Speaker ${device.deviceId.slice(0, 8)}...`}
                          </span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Refresh Devices Button */}
              <div className="px-4 py-2">
                <button
                  onClick={() => {
                    getMics();
                    setShowMicDropdown(false);
                  }}
                  className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#7700ff]/80 transition-colors"
                >
                  <img
                    src="/icons/refresh.png"
                    alt="Refresh Devices"
                    className=""
                  />
                  <span className="font-medium">REFRESH DEVICES</span>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Video */}
        <div className="relative">
          <div
            className={`flex flex-col items-center gap-1 ${
              isMobileLandscape ? "p-1" : "p-2"
            }`}
          >
            <div className="flex items-center gap-1">
              <img
                src={
                  localWebcamOn
                    ? "/icons/videoCamera.svg"
                    : "/icons/videoOff.svg"
                }
                alt="Video"
                className={`object-cover hover:border-gray-400 transition-all duration-200 ${
                  isMobileLandscape ? "h-5" : ""
                } ${isTogglingWebcam ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={isTogglingWebcam ? undefined : handleToggleWebcam}
                title={localWebcamOn ? "Camera Off" : "Camera On"}
              />
            </div>
            {!isMobileLandscape && (
              <span className="text-xs text-white">Video</span>
            )}
          </div>

          {/* Mobile Video Device Dropdown */}
          {showVideoDropdown && (
            <div
              data-video-dropdown
              className={`absolute w-64 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 ${
                isMobileLandscape
                  ? "right-full top-0 mr-2"
                  : "bottom-full left-1/2 transform -translate-x-1/2 mb-2"
              }`}
            >
              {/* Video Source Section */}
              <div className="px-4 py-2">
                <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                  VIDEO SOURCE
                </div>
                <div className="relative">
                  <div
                    className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm"
                    onClick={() => {
                      setShowVideoSourceDropdown(!showVideoSourceDropdown);
                    }}
                  >
                    <div className="flex items-center gap-3 min-w-0 flex-1">
                      <img
                        src="/icons/videoCamera.svg"
                        alt="Camera"
                        className="flex-shrink-0"
                      />
                      <span className="font-medium truncate min-w-0">
                        {selectedWebcam?.label || "Select camera"}
                      </span>
                    </div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      className="flex-shrink-0 ml-2"
                    >
                      <path
                        d="M3.5 5.5L8 10l4.5-4.5"
                        stroke="currentColor"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      />
                    </svg>
                  </div>

                  {/* Camera List */}
                  {showVideoSourceDropdown && (
                    <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                      {webcams.map((device) => (
                        <button
                          key={device.deviceId}
                          className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                          onClick={() => {
                            changeWebcam(device.deviceId);
                            setShowVideoDropdown(false);
                          }}
                        >
                          <img
                            src="/icons/videoCamera.svg"
                            alt="Camera"
                            className="flex-shrink-0"
                          />
                          <span className="truncate min-w-0">
                            {device.label ||
                              `Camera ${device.deviceId.slice(0, 8)}...`}
                          </span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Mirror Camera View Option */}
              <div className="px-4 py-2">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-white text-sm">Mirror Camera View</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="px-4 py-2 space-y-2">
                <button
                  onClick={() => {
                    setShowVirtualBackgroundModal(true);
                    setShowVideoDropdown(false);
                  }}
                  className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                >
                  <svg
                    className="w-4 h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  <span className="font-medium">CHANGE BACKGROUND</span>
                </button>

                <button
                  onClick={() => {
                    getWebcams();
                    setShowVideoDropdown(false);
                  }}
                  className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                >
                  <img
                    src="/icons/refresh.png"
                    alt="Refresh Devices"
                    className=""
                  />
                  <span className="font-medium">REFRESH DEVICES</span>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Chat */}
        <button
          onClick={() => {
            setSideBarMode((s) =>
              s === sideBarModes.CHAT ? null : sideBarModes.CHAT
            );
            setUnreadChat(false);
          }}
          className={`flex flex-col items-center gap-1 relative ${
            isMobileLandscape ? "p-1" : "p-2"
          }`}
          title="Chat"
        >
          <img
            src="/icons/chat.svg"
            alt="Chat"
            className={isMobileLandscape ? "w-5 h-5" : "w-5 h-5"}
          />
          {!isMobileLandscape && (
            <span className="text-xs text-white">Chat</span>
          )}
          {unreadChat && (
            <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></div>
          )}
        </button>

        {/* Logout */}
        <button
          onClick={() => {
            handleLeaveModal();
          }}
          className={`flex flex-col items-center gap-1 ${
            isMobileLandscape ? "p-1" : "p-2"
          }`}
          title="Logout"
        >
          <img src="/icons/logout.svg" alt="Logout" className="w-5 h-5" />
          {!isMobileLandscape && (
            <span className="text-xs text-white">Logout</span>
          )}
        </button>

        {/* Options */}
        {!isMobileLandscape && (
          <button
            onClick={() => {
              setShowMobilePanel(true);
            }}
            className={`flex flex-col items-center gap-1 ${
              isMobileLandscape ? "p-1" : "p-2"
            }`}
            title="Options"
          >
            <img src="/icons/options.svg" alt="Options" className="w-5 h-5" />
            <span className="text-xs text-white">Options</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileBottomBar;
